import { ClientSymbolExtraColumn } from '../symbolClient.interface';

const EXPORT_UNSUPPORTED_SORT_FIELDS: ReadonlySet<string> = new Set([
  ClientSymbolExtraColumn.TobMinSpread,
  ClientSymbolExtraColumn.TobMaxSpread,
]);

export const filterExportSortFields = (sortFields: string[]): string[] =>
  sortFields.filter((field) => {
    const baseField = field.startsWith('-') ? field.slice(1) : field;
    return !EXPORT_UNSUPPORTED_SORT_FIELDS.has(baseField);
  });
